import {
  SHOW_LOADING,
  HIDE_LOADING,
  OPEN_DIALOG,
  CLOSE_DIALOG,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CHECK_PASSWORD_STRENGTH_SUCCESS,
  CHECK_PASSWORD_STRENGTH_FAILURE,
} from './password.constants'
import { StrengthT } from '../../Common/PasswordStrengthIndicator'
import { Reducer } from '@reduxjs/toolkit'
import { PasswordAction } from './password.actions'

interface PasswordState {
  valid: boolean,
  loading: boolean,
  error: string,
  strength: StrengthT,
  dialogOpen: boolean,
}

const initialState: PasswordState = {
  valid: false,
  loading: false,
  error: '',
  strength: 'EMPTY',
  dialogOpen: false,
}

const reducer: Reducer<PasswordState, PasswordAction> = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADING:
      return { ...state, loading: true }
    case HIDE_LOADING:
      return { ...state, loading: false }
    case OPEN_DIALOG:
      return { ...state, dialogOpen: true }
    case CLOSE_DIALOG:
      return initialState
    case CHANGE_PASSWORD_SUCCESS:
      return initialState
    case CHANGE_PASSWORD_FAILURE:
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
      return { ...state, error: (action.error as $TSFIXME).message }
    case CHECK_PASSWORD_STRENGTH_SUCCESS:
      // eslint-disable-next-line no-case-declarations -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
      const { strength, valid } = action.status
      return { ...state, strength, valid }
    case CHECK_PASSWORD_STRENGTH_FAILURE:
      return state
    default:
      return state
  }
}

export default reducer
